var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Smartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 15H28a4 4 0 00-4 4v38a4 4 0 004 4h20a4 4 0 004-4V19a4 4 0 00-4-4zm0 42H28V19h20v38zm-12-6.5a2 2 0 114 0 2 2 0 01-4 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Smartphone.f57fe2d6.svg";
export { SvgH1Smartphone as ReactComponent };